import axios from "axios";
import React from "react";
import { jsonHeader } from '../util/GeneralUtil'
const apiUrl = process.env.REACT_APP_API_URL;


async function getAll(payload) {
    const result = await axios.post(apiUrl + "/admin/dashboard",payload,{
        headers: jsonHeader}
    );
    return result.data || [];
}

async function getAll2(payload) {
    const result = await axios.post(apiUrl + "/admin/dashboard2",payload,{
        headers: jsonHeader}
    );
    return result.data || [];
}

export const DashBoardService = {
    getAll,
    getAll2
}